module.exports = __webpack_public_path__ + "assets/img/Type E (70).3ba1b6b9.jpg";